import { useState } from 'react'

import { useAppVersion } from 'hooks/useAppVersion'
import { Alert, Icon, Typography } from '@themenu/design-system'

import { UnstyledButton } from './styles'

export function UpdateVersionAlert() {
  const [dismissed, setDismissed] = useState(false)
  const { data, isLoading } = useAppVersion()

  if (dismissed || isLoading || data === process.env.NEXT_PUBLIC_BUILD_ID) {
    return null
  }

  return (
    <div className="sticky z-[2] bottom-8 w-full border border-border-default rounded-8">
      <Alert severity="warning" icon="information">
        <div className="flex justify-between items-start gap-32">
          <div>
            <Typography variant="body" weight="medium">
              Olá! Acabamos de implementar algumas atualizações na sua
              Dashboard.{' '}
              <Typography
                variant="body"
                component="a"
                display="inline"
                href={window.location.href}
              >
                Clique aqui para atualizar a ferramenta
              </Typography>
            </Typography>
            <Typography variant="body">
              Não se preocupe: é tão rápido quanto atualizar a página web!
            </Typography>
          </div>
          <UnstyledButton onClick={() => setDismissed(true)}>
            <Icon name="cancel" size={16} />
          </UnstyledButton>
        </div>
      </Alert>
    </div>
  )
}
